import.meta.glob(['../images/**',]);

import './bootstrap';
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, deleteToken } from "firebase/messaging";
import './notifications';
import './hearbeat';
import './chat';
import ApexCharts from 'apexcharts'
import '../../vendor/masmerise/livewire-toaster/resources/js'; // Livewire toaster

// import { lenisMain, mobile } from './lenis';
// import './alpineStore';

document.addEventListener('alpine:init', () => {
    Alpine.store('activeComponent', {
        current: ''
    })
    Alpine.store('showChat', {
        on: false
    })
    //console.log(Alpine.store('activeComponent').current)
})


if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
        .then(function (registration) {
            //console.log('Service Worker registered with scope:', registration.scope);
        }).catch(function (error) {
            //console.log('Service Worker registration failed:', error);
        });
}

function handlePermissionChange() {
    if (Notification.permission === 'denied' || Notification.permission === 'default') {
        const token = localStorage.getItem('fcm_token');
        if (token) {
            unsubscribeToken(token);
            localStorage.removeItem('fcm_token');
        }
    }
}

function registerToken(token) {
    fetch('/register-token', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken,
        },
        body: JSON.stringify({ token: token })
    })
        .then(response => response.json())
        .then(data => console.log(data))
        .catch(error => console.error('Error:', error));
}

// Function to delete FCM token
function unsubscribeToken(token) {
    deleteToken(messaging, token).then(() => {
        //console.log('Token deleted successfully.');
        fetch('/delete-token', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken,
            },
            body: JSON.stringify({ token: token })
        })
            .then(response => response.json())
            .then(data => console.log(data))
            .catch(error => console.error('Error:', error));
    }).catch((err) => {
        //console.error('Error deleting token:', err);
    });
}

const firebaseConfig = {
    apiKey: "AIzaSyCHWGNj5D6GUiQGm2hZlkgovmWy2Ut2zJk",
    authDomain: "standapp-2024.firebaseapp.com",
    projectId: "standapp-2024",
    storageBucket: "standapp-2024.appspot.com",
    messagingSenderId: "102449983528",
    appId: "1:102449983528:web:c18be964fdfad0e14a051d",
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);
//console.log(messaging)

const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

let tokenTest;

$('.testBtn').on('click', function () {
    registerToken(tokenTest);
})

// Request permission and register token
Notification.requestPermission()
    .then((permission) => {
        if (permission === 'granted') {
            return getToken(messaging, { vapidKey: 'BN8GvRltwhkJPD8qaDJAh6vgDZHolxAuB_SMpbRplWtQ0N9uAdUGZw2uJ6zDR-uN3454AM-x6CAyryqAMa4Qy-o' }); // Replace with your actual VAPID public key
        } else {
            //console.error('Permission not granted for Notification');
        }
    })
    .then((token) => {
        if (token) {
            //console.log('FCM Token:', token);
            tokenTest = token;
            registerToken(token);
            localStorage.setItem('fcm_token', token);
        }
    })
    .catch((err) => {
        //console.error('catch', err);
    });

onMessage(messaging, (payload) => {
    //console.log('Message received. ', payload);
    // Customize notification here
    const notificationTitle = payload.notification.title;
    const notificationOptions = {
        body: payload.notification.body,
        icon: payload.notification.icon,
    };

    if (Notification.permission === 'granted') {
        new Notification(notificationTitle, notificationOptions);
    }
});

setInterval(() => {
    handlePermissionChange();
}, 5000);


let currentChannelId = null;
Livewire.on('change-chat-channel', (event) => {

    if (currentChannelId) {
        Echo.leave('conversation.' + currentChannelId);
        Echo.leave('conversation.' + currentChannelId + '.readMessages');
    }

    currentChannelId = event.conversationId;

    // listen for new messages
    Echo.private('conversation.' + event.conversationId).listen('Chat', (event) => {
        Livewire.dispatch('listenForMessage', { id: event.message.id, content: event.message.content });
    })

    // listen for read messages status change
    Echo.private('conversation.' + event.conversationId + '.readMessages').listen('ChatMessageStatus', (event) => {
        Livewire.dispatch('setReadStatus', { readMessagesIds: event.readMessagesIds });
        //console.log(event.readMessagesIds)
    })
});

Livewire.on('leave-chat-channel', (event) => {
    if (currentChannelId) {
        Echo.leave('conversation.' + currentChannelId);
        Echo.leave('conversation.' + currentChannelId + '.readMessages');
    }
});

// joining presence channels
Livewire.on('join-presence-channels', (event) => {

    event.channelIds.forEach(channelId => {
        window.Echo.join(`team-users.${channelId}`)
            .here(users => {
                //console.log(`Users currently in room ${channelId}:`, users);
            })
            .joining(user => {
                Livewire.dispatch('member-presence-changed', { id: user.id, action: 'join' });
                //console.log(`User joined room ${channelId}:`, user);
            })
            .leaving(user => {
                Livewire.dispatch('member-presence-changed', { id: user.id, action: 'leave' });
                //console.log(`User left room ${channelId}:`, user);
            });
    });
})

document.addEventListener('livewire:load', () => {
    document.addEventListener('livewire-upload-progress', function (event) {
        //console.log(event);
    });
});

Livewire.on('startQrReader', () => {
    console.log('livewire action to start scanner triggered')
    startScanner();
});

Livewire.on('stopQrReader', () => {
    closeScanner();
});


let html5QrCode;

async function startScanner() {
    try {
        console.log('scaner function started')
        const scannerOverlay = document.getElementById("scanner-overlay");
        scannerOverlay.style.display = "block";

        if (!html5QrCode) {
            html5QrCode = new Html5Qrcode("qr-reader");
            console.log(html5QrCode)
        }

        // Check if camera is available first
        const cameras = await Html5Qrcode.getCameras();
        console.log("Available cameras:", cameras);

        if (cameras && cameras.length === 0) {
            throw new Error("No cameras found");
        }

        // Safari-specific camera constraints
        let cameraConfig;
        if (cameras && cameras.length > 0) {
            // Try to find back camera first
            const backCamera = cameras.find(camera =>
                camera.label.toLowerCase().includes('back') ||
                camera.label.toLowerCase().includes('rear') ||
                camera.label.toLowerCase().includes('environment')
            );

            if (backCamera) {
                cameraConfig = backCamera.id;
                console.log("Using back camera:", backCamera.label);
            } else {
                // Fallback to first available camera
                cameraConfig = cameras[0].id;
                console.log("Using first available camera:", cameras[0].label);
            }
        } else {
            // Fallback to constraint-based approach
            cameraConfig = { facingMode: "environment" };
            console.log("Using constraint-based camera config");
        }

        // Start scanning with Safari-compatible config
        await html5QrCode.start(
            cameraConfig,
            {
                fps: 10,
                qrbox: { width: 300, height: 300 },
                aspectRatio: 1.0,
                // Safari-specific options
                videoConstraints: {
                    width: { ideal: 1280 },
                    height: { ideal: 720 },
                    facingMode: "environment"
                }
            },
            (decodedText, decodedResult) => {
                console.log("QR Code scanned:", decodedText);
                html5QrCode.stop().then(() => {
                    //closeScanner();
                    if (decodedText.startsWith('http')) {
                        const url = new URL(decodedText);
                        console.log(url);
                        window.location.href = url.href;
                    } else {
                        alert("QR code scanned: " + decodedText);
                    }
                }).catch(err => {
                    console.error("Error stopping scanner:", err);
                    closeScanner();
                });
            },
            (errorMessage) => {
                // Handle scan errors silently
                console.log("Scan error:", errorMessage);
            }
        );

        console.log("Scanner started successfully");

    } catch (err) {
        console.error("Camera start error:", err);

        // More specific error messages for Safari
        let errorMsg = "Could not start camera. ";
        if (err.name === 'NotAllowedError') {
            errorMsg += "Camera permission denied. Please allow camera access and try again.";
        } else if (err.name === 'NotFoundError') {
            errorMsg += "No camera found on this device.";
        } else if (err.name === 'NotReadableError') {
            errorMsg += "Camera is already in use by another application.";
        } else if (err.name === 'OverconstrainedError') {
            errorMsg += "Camera constraints cannot be satisfied.";
        } else if (err.name === 'SecurityError') {
            errorMsg += "Camera access blocked for security reasons. Make sure you're using HTTPS.";
        } else {
            errorMsg += err.message || "Unknown error occurred.";
        }

        alert(errorMsg);
        closeScanner();
    }
}

// Close scanner when clicking outside the scanner area
document.getElementById("scanner-overlay").addEventListener("click", function (e) {
    if (e.target === this) {
        closeScanner();
    }
});

// Close scanner with Escape key
document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
        closeScanner();
    }
});
function closeScanner() {
    const scannerOverlay = document.getElementById("scanner-overlay");
    scannerOverlay.style.display = "none";

    if (html5QrCode) {
        html5QrCode.stop().then(() => {
            console.log("Scanner stopped");
        }).catch((err) => {
            console.error("Error stopping scanner:", err);
        });
    }
}

if (navigator.permissions) {
    navigator.permissions.query({ name: 'camera' }).then(result => {
        console.log("Camera permission:", result.state);
    }).catch(err => {
        console.warn("Permissions API not supported:", err);
    });
}

$(document).on('click', '.share-btn', async function () {
    const url = $(this).data('url');

    if (!navigator.share) {
        console.warn("Web Share API not supported.");
        return;
    }

    try {
        await navigator.share({
            title: "Storio AI",
            url: url
        });
    } catch (err) {
        console.error("Share failed:", err.message);
    }
});







